// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>

const styles = theme => ({
  mobileInputsContainer: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    alignItems: 'center',
  },
  marginTop: {
    paddingTop: 20,
  },
  inputsRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    [theme.breakpoints.down(500)]: {
      flexDirection: 'column',
      alignItems: 'center',
    },
  },
});

export default styles;
